// src/app/redux/actions/modeEvaluationActions.js

export const FETCH_MODES_EVALUATION_REQUEST = "FETCH_MODES_EVALUATION_REQUEST";
export const FETCH_MODES_EVALUATION_SUCCESS = "FETCH_MODES_EVALUATION_SUCCESS";
export const FETCH_MODES_EVALUATION_FAIL    = "FETCH_MODES_EVALUATION_FAIL";

export const CREATE_MODE_EVALUATION_REQUEST = "CREATE_MODE_EVALUATION_REQUEST";
export const CREATE_MODE_EVALUATION_SUCCESS = "CREATE_MODE_EVALUATION_SUCCESS";
export const CREATE_MODE_EVALUATION_FAIL    = "CREATE_MODE_EVALUATION_FAIL";

export const UPDATE_MODE_EVALUATION_REQUEST = "UPDATE_MODE_EVALUATION_REQUEST";
export const UPDATE_MODE_EVALUATION_SUCCESS = "UPDATE_MODE_EVALUATION_SUCCESS";
export const UPDATE_MODE_EVALUATION_FAIL    = "UPDATE_MODE_EVALUATION_FAIL";

export const DELETE_MODE_EVALUATION_REQUEST = "DELETE_MODE_EVALUATION_REQUEST";
export const DELETE_MODE_EVALUATION_SUCCESS = "DELETE_MODE_EVALUATION_SUCCESS";
export const DELETE_MODE_EVALUATION_FAIL    = "DELETE_MODE_EVALUATION_FAIL";

export const SET_MODE_EVALUATION_LOADING  = "SET_MODE_EVALUATION_LOADING";
export const CLEAR_MODE_EVALUATION_ERROR  = "CLEAR_MODE_EVALUATION_ERROR";

// Action creators
export const fetchModesEvaluationRequest = () => ({ type: FETCH_MODES_EVALUATION_REQUEST });
export const fetchModesEvaluationSuccess = (data) => ({ type: FETCH_MODES_EVALUATION_SUCCESS, payload: data });
export const fetchModesEvaluationFail    = (error) => ({ type: FETCH_MODES_EVALUATION_FAIL, error });

export const createModeEvaluationRequest = (payload) => ({ type: CREATE_MODE_EVALUATION_REQUEST, payload });
export const createModeEvaluationSuccess = (data)    => ({ type: CREATE_MODE_EVALUATION_SUCCESS, payload: data });
export const createModeEvaluationFail    = (error)   => ({ type: CREATE_MODE_EVALUATION_FAIL, error });

export const updateModeEvaluationRequest = (id, payload) => ({ type: UPDATE_MODE_EVALUATION_REQUEST, payload: { id, payload } });
export const updateModeEvaluationSuccess = (data)        => ({ type: UPDATE_MODE_EVALUATION_SUCCESS, payload: data });
export const updateModeEvaluationFail    = (error)       => ({ type: UPDATE_MODE_EVALUATION_FAIL, error });

export const deleteModeEvaluationRequest = (id)    => ({ type: DELETE_MODE_EVALUATION_REQUEST, payload: { id } });
export const deleteModeEvaluationSuccess = (id)    => ({ type: DELETE_MODE_EVALUATION_SUCCESS, payload: { id } });
export const deleteModeEvaluationFail    = (error) => ({ type: DELETE_MODE_EVALUATION_FAIL, error });

export const setModeEvaluationLoading = (loading) => ({ type: SET_MODE_EVALUATION_LOADING, payload: loading });
export const clearModeEvaluationError = ()        => ({ type: CLEAR_MODE_EVALUATION_ERROR });